
import Vue from "vue";
import { Component } from "vue-property-decorator";
import TogglePanel from "../../components/TogglePanel.vue";
import IconButtonShuffle from "../../components/IconButtonShuffle.vue";
import { globalStore, configStore, singularityStore } from "@/store/store";
import BrandTypographyPicker from "./BrandTypographyPicker.vue";
import { Font } from "@/types/fonts";
import {
  updateGlobalTypography,
  updateGlobalTypographyRatio,
  shuffleTypography
} from "@/lib/singularity/brand/typography";
import BrandToggleFontSizes from "./BrandToggleFontSizes.vue";
import { logEvent } from "@/util/tracking";

@Component({
  components: {
    TogglePanel,
    IconButtonShuffle,
    BrandTypographyPicker,
    BrandToggleFontSizes
  }
})
export default class BrandManageTypography extends Vue {
  get globalTypography() {
    return globalStore.globalSettings.settings.typography;
  }

  get buttonPrimaryTypographySlug() {
    return (
      globalStore.globalSettings.settings.buttons?.primary?.typography
        ?.typography?.custom?.customTypography?.fontFamily.breakpoint_base ||
      null
    );
  }

  get buttonPrimaryTypographyFont() {
    return configStore.fonts.filter(
      (font: Font) =>
        font.slug ===
        (this.buttonPrimaryTypographySlug
          ? this.buttonPrimaryTypographySlug
          : this.bodyFont?.slug)
    )[0];
  }
  
  get isPanelOpen() {
    return singularityStore.brandPanelState?.openedPanel === "typography";
  }

  get headingFont() {
    if (!this.globalTypography) {
      return null;
    }
    return configStore.fonts.filter(
      (font: Font) => font.slug === this.globalTypography.heading_font
    )[0];
  }

  get bodyFont() {
    if (!this.globalTypography) {
      return null;
    }
    return configStore.fonts.filter(
      (font: Font) => font.slug === this.globalTypography.body_font
    )[0];
  }

  shuffle() {
    shuffleTypography();
    logEvent("FutureLayer Brand: Typography Shuffled");
  }

  updateFontRatio(ratio: number) {
    updateGlobalTypographyRatio(ratio);
  }

  updateFont(
    type: "heading_font" | "body_font" | "buttons",
    slug: Font["slug"]
  ) {
    updateGlobalTypography(type, slug);
    logEvent("FutureLayer Brand: Typography Updated", { type, slug });
  }
}
